import styled from 'styled-components'

export const StyledLanguageSelection = styled.div``
